import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import React, { Component } from 'react'
import ChatIcon from '../../WebScreen/ChatBox/ChatIcon'
import MobCopyright from '../MobCopyright'
import MobileCuramLifeCard from '../MobileCuramLifeCard'
import MobileFooter from '../MobileFooter'
import Modal1 from 'react-awesome-modal'

export default class MobileCuramLifeCardNotification extends Component {
  goBack = () => {
    this.props.history.goBack()
  }

  render() {
    return (
      <div>
        <div class="digitalcard_header" style={{ position: 'fixed', overflow: 'hidden' }}>
          <ArrowBackIcon style={{ width: '24px', height: '24px', color: '#2e3192' }} onClick={() => this.goBack()} />
          <div class="digitalcard_headerdiv" style={{ marginLeft: 10, marginRight: 10 }}>
            UHF / Curam Wellness Center™
          </div>
        </div>
        <div style={{ padding: '35px', marginTop: '10%', height: '75vh' }}>
          <MobileCuramLifeCard />
        </div>

        <div style={{ bottom: '9vh', position: 'relative' }}>
            <ChatIcon showAIChatIcon={true} />
          <ChatIcon setAI={() => this.setState({ isAI: true })} />
        </div>
        <div style={{ bottom: '9vh', position: 'relative' }}>
          <MobCopyright />
        </div>
        {/* <MobileFooter /> */}
        <div class="fixed-bottom">
          <MobileFooter />
        </div>

        <Modal1 visible={this.state.isAI} width="90%" effect="fadeInUp">
          <div style={{ width: '90vw' }}>
            <div class="mqalert_modal_text">
              This service is currently offline. Please try again later.
            </div>
            <br />
            <div class="mqalert_button_div">
              <button className="mqalert_button" onClick={() => this.setState({ isAI: false })}>
                OK
              </button>
            </div>
          </div>
        </Modal1>
      </div>
    )
  }
}
